<template>
  <div class="row f-row justify-content-center">
    <div
      class="row f-row mt-1 mb-1 justify-content-center"
      style="vertical-align: middle!important;"
    >
      <div class="col col-auto mt-1 mb-1 txt-label-primary-2 text-center">
        Company:&nbsp;
      </div>
      <div class="col col-2 ml-2 mr-3 text-left">
        <Dropdown
          v-model="newSelectedCompany"
          :options="companies"
          @change="onUserCompanySelection"
          optionLabel="company_name"
          optionValue="id"
          placeholder="Select a Company"
          scrollHeight="400px"
          :filter="true"
        >
          <template #value="slotProps">
            <span style="color: var(--textactive-2)">{{
              companies[slotProps.value].company_name
            }}</span>
          </template>
          <template #option="slotProps">
            <div class="country-item">
              <div>{{ slotProps.option.company_name }}</div>
            </div>
          </template>
        </Dropdown>
      </div>
      <div class="col col-auto ml-1 txt-label-primary-2 text-center">
        Portfolio:&nbsp;
      </div>
      <div class="col col-2 mr-2 text-left">
        <Dropdown
          v-model="newSelectedPortfolio"
          :options="
            portfolios.map(function(d, i) {
              return { asset: d.name, id: i };
            })
          "
          @change="onUserPortfolioSelection"
          optionLabel="asset"
          optionValue="id"
          placeholder="Select a Portfolio"
          scrollHeight="400px"
          :filter="true"
        >
          <template #value="slotProps">
            <span style="color: var(--textactive-2)">{{
              portfolios[slotProps.value].name
            }}</span>
          </template>
          <template #option="slotProps">
            <div class="country-item">
              <div>{{ slotProps.option.asset }}</div>
            </div>
          </template>
        </Dropdown>
      </div>
      <div class="col col-auto ml-2 txt-label-primary-2 text-center">
        {{ selectedAssetType === 0 ? "Currency" : "Commodity" }}:&nbsp;
      </div>
      <div class="col col-2 text-left">
        <Dropdown
          v-model="newSelectedAsset"
          :options="
            currencies.map(function(d, i) {
              return { asset: d, id: i };
            })
          "
          @change="onUserCurrencySelection"
          optionLabel="asset"
          optionValue="id"
          placeholder="Select a Currency"
          scrollHeight="400px"
          :filter="true"
        >
          <template #value="slotProps">
            <span style="color: var(--textactive-2)">{{
              currencies[slotProps.value].toUpperCase()
            }}</span>
          </template>
          <template #option="slotProps">
            <div class="country-item">
              <div>{{ slotProps.option.asset.toUpperCase() }}</div>
            </div>
          </template>
        </Dropdown>
      </div>
      <div class="col col-auto ml-2 txt-label-primary-2 text-center">
        &nbsp;<span v-show="selectedAssetType === 1">
          <i
            class="fa fa-question-circle txt-label-primary-2"
            style="display: inline; font-size: 1.3rem!important;"
            @mouseover="onHoverHelp(true)"
            @mouseleave="onHoverHelp(false)"
          ></i>
        </span>
        &nbsp;&nbsp;Buckets:&nbsp;
      </div>
      <div class="col col-2" style="top:5px !important;">
        <BucketSelector
          :blue="true"
          :includeTitle="false"
          :pickedDateInterval="pickedBucket"
          @eventOnChangeInterval="onBucketChange"
        />
      </div>
    </div>
    <div class="row justify-content-md-center mt-2 mb-1">
      <div class="col col-auto txt-label-primary-2 text-center">
        New hedge ({{
          selectedAssetType === 0
            ? currencies[newSelectedAsset].slice(0, 3)
            : expoCurrency.fk_idunit
        }}):&nbsp;
      </div>
      <div class="col col-2 mr-2">
        <InputNumber
          :blue="true"
          :value="totalNewHedge"
          @input="(val) => onUserNewHedgeChange(val)"
        />
      </div>
      <div class="col col-auto txt-label-primary-2 text-center">
        New %:&nbsp;
      </div>
      <div class="col col-2 mr-2">
        <InputPercent
          :blue="true"
          :value="totalNewPercent"
          @input="(val) => onUserTotalNewPercentChange(val)"
        />
      </div>
      <div class="col col-auto txt-label-primary-2 text-center">
        % of required:&nbsp;
      </div>
      <div class="col col-2 mr-2">
        <InputPercent
          :blue="true"
          :value="totalPercOfRequired"
          @input="(val) => onUserTotalPercOfRequiredChange(val)"
        />
      </div>
    </div>

    <div class="row f-row justify-content-center">
      <div
        class="col col-12 text-center progress-div"
        v-if="showLoading"
        style="top: 35vh;"
      >
        <QSLoading
          :isLoading="showLoading"
          :size="40"
          :colorTheme="colorTheme"
        />
      </div>
      <div
        class="align-content-center"
        style="height: 100%; width:100%; overflow: auto;"
      >
        <table class="table table-sm table-borderless real_time_table mt-2">
          <thead class="table-headers text-center align-center thead">
            <tr>
              <th style="width:5%">#</th>
              <th style="width:9.5%">Date</th>
              <th style="width:9.5%" v-if="selectedAssetType === 0">
                Expo ({{ expoCurrency }})
              </th>
              <th style="width:9.5%" v-else>
                Expo ({{ expoCurrency.fk_idunit }})
              </th>
              <!--            <th style="width:9.5%">HEDGE</th>-->
              <th style="width:9.5%">Hedge</th>
              <th style="width:9.5%">Program</th>
              <!-- <th style="width:5%">EXCESS</th> -->
              <th style="width:9.5%">Required</th>
              <!--            <th style="width:9.5%">EXCESS</th>-->
              <th style="width:9.5%" v-if="selectedAssetType === 0">
                New hedge ({{ currencies[newSelectedAsset].slice(0, 3) }})
              </th>
              <th style="width:9.5%" v-else>
                New hedge ({{ expoCurrency.fk_idunit }})
              </th>
              <th style="width:9.5%">New %</th>
              <th style="width:9.5%">Total %</th>
            </tr>
          </thead>
        </table>
      </div>
    </div>
    <div
      class="align-content-center"
      style="height: 100%; width: 100%; overflow: auto;"
      v-bind:class="{
        strategiesPortTableHeight1: showCalculator,
        strategiesPortTableHeight2: !showCalculator,
      }"
    >
      <table class="table table-sm table-borderless real_time_table">
        <tbody>
          <tr v-for="(item, index) in newSelectedHedge" :key="index" class="tr">
            <td
              style="width:5%"
              class="text-center"
              v-bind:class="{ 'row-hover': highlightRow === index }"
              @mouseover="onHoverRow(index)"
              @mouseleave="onHoverRow(-1)"
            >
              {{ index + 1 }}
            </td>
            <td
              style="width:9.5%"
              v-bind:class="{ 'row-hover': highlightRow === index }"
              @mouseover="onHoverRow(index)"
              @mouseleave="onHoverRow(-1)"
            >
              {{ item.date }}
            </td>
            <td
              style="width:9.5%; font-weight: bold;"
              class="expo"
              v-bind:class="{ 'row-hover': highlightRow === index }"
              @mouseover="onHoverRow(index)"
              @mouseleave="onHoverRow(-1)"
            >
              {{ item.expo | formatM }}
            </td>
            <!--            <td style="width:9.5%" class="hedge">{{ item.hedge | formatM }}</td>-->
            <td
              style="width:9.5%; font-weight: bold;"
              class="hedge"
              v-bind:class="{ 'row-hover': highlightRow === index }"
              @mouseover="onHoverRow(index)"
              @mouseleave="onHoverRow(-1)"
            >
              {{ item.expo !== 0 ? item.hedge / item.expo : 0 | formatPercent }}
            </td>
            <td
              style="width:9.5%; font-weight: bold;"
              class="program"
              v-bind:class="{ 'row-hover': highlightRow === index }"
              @mouseover="onHoverRow(index)"
              @mouseleave="onHoverRow(-1)"
            >
              {{
                item.expo !== 0 ? item.program / item.expo : 0 | formatPercent
              }}
            </td>
            <td
              style="width:9.5%; font-weight: bold;"
              v-bind:class="{ 'row-hover': highlightRow === index }"
              @mouseover="onHoverRow(index)"
              @mouseleave="onHoverRow(-1)"
            >
              {{ (item.program - item.hedge) | formatM }}
            </td>
            <td
              style="width:9.5%"
              v-bind:class="{ 'row-hover': highlightRow === index }"
              @mouseover="onHoverRow(index)"
              @mouseleave="onHoverRow(-1)"
            >
              <InputNumber
                v-model.number="item.newHedge"
                :tableFormat="true"
                @input="updateNewHedge(item)"
              />
            </td>
            <td
              style="width:9.5%"
              v-bind:class="{ 'row-hover': highlightRow === index }"
              @mouseover="onHoverRow(index)"
              @mouseleave="onHoverRow(-1)"
            >
              <InputPercent
                v-model.number="item.newHedgePercent"
                :tableFormat="true"
                @input="updateNewPercentage(item)"
              />
            </td>
            <td
              style="width:9.5%"
              v-bind:class="{ 'row-hover': highlightRow === index }"
              @mouseover="onHoverRow(index)"
              @mouseleave="onHoverRow(-1)"
            >
              <InputPercent
                v-model.number="item.totalHedgePercent"
                :tableFormat="true"
                @input="updateTotalNewPercentage(item)"
              />
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div
      class="align-content-center"
      style="height: 100%; width: 100%; overflow: auto;"
    >
      <table class="table table-sm table-borderless real_time_table">
        <thead class="table-headers text-center align-center thead">
          <tr>
            <th style="width:5%">TOTAL</th>
            <th style="width:9.5%"></th>
            <th style="width:9.5%">{{ totExpo | formatM }}</th>
            <!--            <th style="width:9.5%">{{ totHedge | formatM }}</th>-->
            <!--            <th style="width:9.5%"></th>-->
            <th style="width:9.5%">
              {{ noNanNum(totHedge / totExpo) | formatPercent }}
            </th>
            <th style="width:9.5%">
              {{ noNanNum(totProgram / totExpo) | formatPercent }}
            </th>
            <th style="width:9.5%">{{ totRequired | formatM }}</th>
            <!--            <th style="width:9.5%">{{ totExcess | formatM }}</th>-->
            <th style="width:9.5%; font-size: 1rem;">
              {{ allSubTotal | formatM }}
            </th>
            <th style="width:9.5%; font-size: 1rem;">
              {{ newPercent | formatPercent }}
            </th>
            <th style="width:9.5%; font-size: 1rem;">
              {{ allPercent | formatPercent }}
            </th>
          </tr>
        </thead>
      </table>
    </div>
  </div>
</template>

<script>
import BucketSelector from "@/components/intervals/AnalyticsInterval";
import Dropdown from "primevue/dropdown";
import InputNumber from "@/components/InputNumber";
import InputPercent from "@/components/InputPercent";
import QSLoading from "@/components/QSLoading.vue";
import {
  darkBackground,
  grayLightBackground,
  textactive2,
} from "@/_core/_helpers/_parametric_tools";
import { format, select } from "d3";
import { noNanNum } from "@/_core/_helpers/_helpers.js";

export default {
  name: "PortfolioTable",
  components: {
    BucketSelector,
    Dropdown,
    InputNumber,
    InputPercent,
    QSLoading,
  },
  props: {
    colorTheme: { required: true, type: Boolean, default: true },
    companies: { required: true, default: () => [] },
    currencies: { required: true, default: () => [] },
    expoCurrency: { required: true, default: "N.A." },
    pickedBucket: { required: true },
    portfolios: { required: true, default: () => [] },
    processData: { required: true },
    selectedAsset: { required: true, default: () => [] },
    selectedAssetType: { required: true, default: () => [] },
    selectedCompany: { required: true, default: () => [] },
    selectedHedge: { required: true, default: () => [] },
    selectedHedgeSignal: { required: true, default: 0 },
    selectedPortfolio: { required: true, default: () => [] },
    showCalculator: { required: true, type: Boolean, default: false },
    showLoading: { required: true },
    totalNewHedge: { required: true, default: () => [] },
    totalNewPercent: { required: true, default: () => [] },
    totalPercOfRequired: { required: true, default: () => [] },
  },
  data() {
    return {
      screenSize: null,
      tooltip: null,
      newSelectedHedge: [],
      hedgeChanged: false,
      noNanNum: null,
      newSelectedCompany: 0,
      newSelectedPortfolio: 0,
      newSelectedAsset: 0,
      loaded: true,
      highlightRow: -1,
    };
  },
  created() {
    this.noNanNum = noNanNum;
  },
  mounted() {
    this.newSelectedCompany = this.selectedCompany;
    this.newSelectedPortfolio = this.selectedPortfolio;
    this.newSelectedAsset = this.selectedAsset;
    this.newSelectedHedge = this.selectedHedge;
    this.screenSize = document.getElementById("whole-page-opt-div");
    this.screenSize = [
      0.2 * this.screenSize.clientHeight,
      0.5 * this.screenSize.clientWidth,
    ];
    this.tooltip = select("#whole-page-opt-div")
      .append("div")
      .style("opacity", 0)
      .style("margin", 0)
      .style("padding", "8px")
      .style("text-align", "center")
      .style("background", darkBackground(this.colorTheme))
      .style("border", grayLightBackground(this.colorTheme))
      .style("color", textactive2(this.colorTheme))
      .attr("class", "tooltip")
      .style("font-size", "0.8rem")
      .style("width", "350px")
      .html("");
  },
  watch: {
    colorTheme() {
      this.tooltip
        .style("background", darkBackground(this.colorTheme))
        .style("border", grayLightBackground(this.colorTheme))
        .style("color", textactive2(this.colorTheme));
    },
    selectedHedgeSignal() {
      this.newSelectedHedge = this.selectedHedge;
    },
    selectedCompany() {
      this.newSelectedCompany = this.selectedCompany;
    },
    selectedPortfolio() {
      this.newSelectedPortfolio = this.selectedPortfolio;
    },
    selectedAsset() {
      this.newSelectedAsset = this.selectedAsset;
    },
  },
  filters: {
    formatM(val) {
      return Math.abs(val) > 1000000000000
        ? format(",.2f")(val / 1000000000000) + "T"
        : Math.abs(val) > 10000000
        ? format(",.2f")(val / 1000000) + "M"
        : format(",.0f")(val);
    },
    formatPercent: function(value) {
      // if (value) {
      return format(".1%")(value);
      // }
    },
  },
  computed: {
    totExpo() {
      return this.newSelectedHedge
        .map((item) => +item.expo)
        .reduce((a, b) => a + b, 0);
    },
    totHedge() {
      return this.newSelectedHedge
        .map((item) => +item.hedge)
        .reduce((a, b) => a + b, 0);
    },
    totProgram() {
      return this.newSelectedHedge
        .map((item) => +item.program)
        .reduce((a, b) => a + b, 0);
    },
    totRequired() {
      return this.newSelectedHedge
        .map((item) => +Math.max(0, item.program - item.hedge))
        .reduce((a, b) => a + b, 0);
    },
    totExcess() {
      return this.newSelectedHedge
        .map((item) => -Math.max(0, item.program - item.hedge))
        .reduce((a, b) => a + b, 0);
    },
    allSubTotal() {
      return this.newSelectedHedge
        .map((item) => +item.newHedge)
        .reduce((a, b) => a + b, 0);
    },
    newPercent() {
      return noNanNum(
        this.newSelectedHedge
          .map((item) => +item.newHedge)
          .reduce((a, b) => a + b, 0) / this.totExpo,
      );
    },
    allPercent() {
      return noNanNum(
        this.newSelectedHedge
          .map((item) => +item.newHedge + item.hedge)
          .reduce((a, b) => a + b, 0) / this.totExpo,
      );
    },
  },
  methods: {
    // === user interactions ===
    onHoverHelp(val) {
      let keys = Object.keys(this.expoCurrency);
      if (val && keys.indexOf("text") > -1) {
        this.tooltip
          .style("opacity", 1)
          .style("left", this.screenSize[1] + "px")
          .style("top", this.screenSize[0] + "px")
          .html(this.expoCurrency.text);
      } else {
        this.tooltip
          .style("left", "-1000000px")
          .style("top", "0px")
          .style("opacity", 0)
          .html("");
      }
    },
    onHoverRow(idx) {
      this.highlightRow = idx;
    },
    onUserCompanySelection() {
      this.$emit("eventOnUserCompanySelection", this.newSelectedCompany);
    },
    onUserPortfolioSelection() {
      this.$emit("eventOnUserPortfolioSelection", this.newSelectedPortfolio);
    },
    onUserCurrencySelection() {
      this.$emit("eventOnUserCurrencySelection", this.newSelectedAsset);
    },
    onUserNewHedgeChange(val) {
      this.$emit("eventOnUserNewHedgeChange", val);
    },
    onUserTotalNewPercentChange(val) {
      this.$emit("eventOnUserTotalNewPercentChange", val);
    },
    onUserTotalPercOfRequiredChange(val) {
      this.$emit("eventOnUserTotalPercOfRequiredChange", val);
    },
    onBucketChange(val) {
      this.$emit("eventOnBucketChange", {
        val: val,
        newSelectedHedge: this.newSelectedHedge,
      });
    },
    emitNewSelectedHedge() {
      this.$emit("eventOnUserChangedHedge", this.newSelectedHedge);
    },
    updateNewHedge(item) {
      if (item.newHedge < 0) {
        item.newHedge = 0;
      }
      item.newHedgePercent = (100 * item.newHedge) / item.expo;
      item.totalHedgePercent = (100 * (item.newHedge + item.hedge)) / item.expo;
      this.emitNewSelectedHedge();
    },
    updateNewPercentage(item) {
      if (item.newHedgePercent < 0) {
        item.newHedgePercent = 0;
      }
      item.newHedge = (item.newHedgePercent / 100) * item.expo;
      item.totalHedgePercent = (100 * (item.newHedge + item.hedge)) / item.expo;
      this.emitNewSelectedHedge();
    },
    updateTotalNewPercentage(item) {
      item.newHedge = (item.totalHedgePercent / 100) * item.expo - item.hedge;
      if (item.newHedge < 0) {
        item.newHedge = 0;
        item.totalHedgePercent = (100 * item.hedge) / item.expo;
      }
      item.newHedgePercent = (100 * item.newHedge) / item.expo;
      this.emitNewSelectedHedge();
    },
  },
};
</script>
<style scoped>
.p-dropdown {
  background: var(--dark-expo-alpha);
}
.p-dropdown:hover,
.p-dropdown:focus:hover,
.p-dropdown:focus,
.p-dropdown.active,
.p-dropdown::after {
  background: var(--expo) !important;
}
</style>
